import * as React from "react";
import {FormattedMessage} from "react-intl";

export default (value: any) => {
    if(Array.isArray(value) && value.length === 0) {
        return <FormattedMessage id="form.validations.required" />;
    }

    if(!value && typeof value !== 'number') {
        return <FormattedMessage id="form.validations.required" />;
    }

    return undefined;
};